<style scoped>
    .confirm-message {
        text-align: center;
    }
</style>

<template>
<ValidationObserver ref="observer" v-slot="{ invalid }">
    <v-dialog v-model="handleDialog" width="1200" class="common-dialog">
        <v-card color="#F4FEFB">
            <v-card-title class="justify-center text-h5">メンバー追加</v-card-title>
                <v-card-text
                    class="common-dialog-message"
                >
                <v-container>
                    <v-row>
                        <v-col cols="12" xl="3">
                            <badge-component tile content="必　須" color="red">
                                <label-component>メンバー</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-select
                                    v-model="user_id"
                                    :items="alertItem.users"
                                    :error-messages="errors"
                                    outlined
                                    clearable
                                    v-disabled-icon-focus
                                    background-color="white"
                                ></v-select>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <badge-component tile color="unset">
                                <label-component>グループ管理者権限</label-component>
                            </badge-component>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                    color="primary"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                        mdi-help-circle
                                    </v-icon>
                                </template>
                                <span>説明</span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <v-switch
                                v-model="team_administrator_privileges"
                                inset
                                :label="team_administrator_privileges? '権限を付与する' : '' "
                            ></v-switch>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <badge-component tile color="unset">
                                <label-component>書類管理者権限　　</label-component>
                            </badge-component>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                    color="primary"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                        mdi-help-circle
                                    </v-icon>
                                </template>
                                <span>説明</span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <v-switch
                                v-model="document_manager"
                                inset
                                :label="document_manager? '権限を付与する' : '' "
                            ></v-switch>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <badge-component tile color="unset">
                                <label-component>親展書類管理者　　</label-component>
                            </badge-component>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                    color="primary"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                        mdi-help-circle
                                    </v-icon>
                                </template>
                                <span>説明</span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <v-switch
                                v-model="confidential_document_manager"
                                inset
                                :label="confidential_document_manager? '権限を付与する' : '' "
                            ></v-switch>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            
            <v-divider></v-divider>
            
            <v-card-actions class="justify-center grey lighten-4 pb-6">
                <v-btn min-width="150px" class="white--text" color="red" large v-on:click="add" :disabled="invalid">
                    <slot name="ok-btn"></slot>
                </v-btn>
                <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="handleDialog = false">
                    <slot name="cancel-btn"></slot>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</ValidationObserver>
</template>

<script>
export default {
    data() {
        return {
            alertItem: this.item, // 子で親のインスタンスを更新するので、一度変数に移す（オブジェクトだが大丈夫か？）
            user_id: '',
            team_administrator_privileges: false,
            document_manager: false,
            confidential_document_manager: false,
        };
    },
    props: {
        item: {
            organization_id: String,
            users: Array,
        },
        // ダイアログの開閉
        addDialog: Boolean,
    },
    computed: {
        handleDialog: {
            get() {
                return this.addDialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:addDialog', value);
            }
        },
    },
    methods: {
        add: function (event) {
            axios.post(
                '/documents/add-organization-users',
                {
                    'user_id': this.user_id,
                    'organization_id': this.alertItem.organization_id,
                    'team_administrator_privileges': this.team_administrator_privileges,
                    'document_manager': this.document_manager,
                    'confidential_document_manager': this.confidential_document_manager,
                }
            ).then(res => {
                // 親コンポーネントへの通知
                if (res.data.success) {
                    this.$emit("success", res.data.message);
                    this.handleDialog = false;
                } else {
                    this.$emit("error", res.data.message);
                }
            }).catch(res => {
              // console.log(res);
                this.success = false;
                this.message = "処理に失敗しました";
                this.$emit("error", "処理に失敗しました");
            }).finally(() => {
            });
        }
    },
};
</script>